module.exports = __webpack_public_path__ + "img/8.09b945f3.jpg";